function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      // 3 Oct 2026 (NNM): watch the main Add to cart button itself, so the bar is there above AND below it
      this.mainForm = [...this.productSection.querySelectorAll('product-form')].find((f) => !f.closest('sticky-atc-panel')) || this.productForm;
      this.addButton = this.mainForm ? this.mainForm.querySelector('button[name="add"]') : null;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.elements_to_shift = [];
      this.waitForShiftElement('#ShopifyChat');
      this.waitForShiftElement('.es-badge-container');

      this.alwaysShow = false;

    }

    waitForShiftElement(selector) {
      waitForElm(selector).then(() => {
        this.initShiftElement(selector);
      });
    }

    initShiftElement(selector) {
      const element = document.querySelector(`${selector}`);

      if (element && !element.classList.contains('will-shift')) {
        element.classList.add('will-shift');
        this.elements_to_shift.push(element);
        this.setShiftAmount();

        if ( !this.classList.contains('sticky-atc-panel--out') ) {
          this.elements_to_shift.forEach((element) => {
            element.classList.add('shifted');
          })
        }
      }
    }

    setShiftAmount() {
      if (this.elements_to_shift) {
        this.elements_to_shift.forEach((element) => {
          element.style.setProperty('--shift-amount', `${this.offsetHeight + this.style.marginBottom}px`);
        })
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        this.setShiftAmount();
        console.log("Recalculated shift amount");
        entries.forEach((entry) => {
          if ((entry.target === this.addButton || entry.target === this.productForm) && !theme.mediaMatches.md) {
            const buttonVisible = this.addButton ? entry.isIntersecting : entry.boundingClientRect.bottom > 0;
            this.classList.toggle('sticky-atc-panel--out', buttonVisible);
            document.body.classList.toggle('nnm-sticky-atc-in', !buttonVisible);
            if (this.elements_to_shift) { 
              this.elements_to_shift.forEach((element) => {
                element.classList.toggle('shifted', !buttonVisible);
              })
            }
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            if (this.elements_to_shift) { 
              this.elements_to_shift.forEach((element) => {
                element.classList.toggle('shifted', !entry.isIntersecting);
              })
            }
          }
        });
      });

      if (this.addButton) observer.observe(this.addButton);
      else if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);
      // 3 Oct 2026 (NNM): set the first state from the button's position straight away, so phones that open
      // the page with the button below the fold get the bar before any scroll (observers can start late)
      if (this.addButton && !theme.mediaMatches.md) {
        const r = this.addButton.getBoundingClientRect();
        const visibleNow = r.bottom > 0 && r.top < window.innerHeight;
        this.classList.toggle('sticky-atc-panel--out', visibleNow);
        document.body.classList.toggle('nnm-sticky-atc-in', !visibleNow);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}